export const environment = {
    production: false,
    // apiUrl: 'http://localhost:8080/api',
    apiUrl: 'https://karma.meskochi.in/api',
    ivBase64Secret: ''
};
